import jsPDF from "jspdf";
import QRCode from "qrcode";
import logo from "../assets/icons/qvh-logo.svg";

const BASE_URL = (process.env.REACT_APP_FE_URL || window.location.origin).replace(/\/$/, "");

function buildUrl(token) {
  return `${BASE_URL}/mos/${token}`;
}

export async function generateMosLinkPdf(token, code, name = null, vorname = null) {
  const url = buildUrl(token);

  // Generate QR as data URL
  const qrDataUrl = await QRCode.toDataURL(url, {
    width: 300,
    margin: 1,
    color: { dark: "#000000", light: "#ffffff" },
  });

  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const pageWidth = 210;
  const margin = 20;
  let y = 20;

  const today = new Date().toLocaleDateString("de-DE");

  // ── Logo ────────────────────────────────────────────────────
  await new Promise((resolve) => {
    const img = new Image();
    img.src = logo;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = 414; canvas.height = 177;
      canvas.getContext("2d").drawImage(img, 0, 0, 414, 177);
      const pngData = canvas.toDataURL("image/png");
      const imgWidth = 40;
      const imgHeight = (177 / 414) * imgWidth;
      const imgX = (pageWidth - imgWidth) / 2;
      doc.addImage(pngData, "PNG", imgX, y, imgWidth, imgHeight);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(100, 100, 100);
      doc.text(`Datum: ${today}`, pageWidth - margin, y + 5, { align: "right" });
      doc.setTextColor(0, 0, 0);

      y += imgHeight + 10;
      resolve();
    };
  });

  // ── Title ────────────────────────────────────────────────────
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("MOS Fragebogen – Zugangslink", pageWidth / 2, y, { align: "center" });
  y += 6;

  // Thin rule under title
  doc.setDrawColor(200, 200, 200);
  doc.line(margin, y, pageWidth - margin, y);
  y += 10;

  // ── QR Code ─────────────────────────────────────────────────
  const qrSize = 58;
  const qrX = (pageWidth - qrSize) / 2;
  doc.addImage(qrDataUrl, "PNG", qrX, y, qrSize, qrSize);
  y += qrSize + 8;

  // ── Section: Link ────────────────────────────────────────────
  doc.setFillColor(235, 235, 235);
  doc.rect(margin - 2, y - 5, pageWidth - margin * 2 + 4, 8, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("Link", margin, y);
  y += 10;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  const urlLines = doc.splitTextToSize(url, pageWidth - margin * 2);
  doc.text(urlLines, margin, y);
  y += urlLines.length * 6 + 10;

  // ── Section: Patient (optional) ──────────────────────────────
  if (name || vorname) {
    doc.setFillColor(235, 235, 235);
    doc.rect(margin - 2, y - 5, pageWidth - margin * 2 + 4, 8, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text("Patient", margin, y);
    y += 12;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    const patientName = [vorname, name].filter(Boolean).join(" ");
    doc.text(patientName, pageWidth / 2, y, { align: "center" });
    y += 12;
  }

  // ── Section: Code ────────────────────────────────────────────
  doc.setFillColor(235, 235, 235);
  doc.rect(margin - 2, y - 5, pageWidth - margin * 2 + 4, 8, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("Zugangscode", margin, y);
  y += 12;

  // Code as plain bold text centered
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
  doc.text(code, pageWidth / 2, y, { align: "center" });
  y += 12;

  // ── Instructions ─────────────────────────────────────────────
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(120, 120, 120);
  const instructions =
    "Öffnen Sie den Link (oder scannen Sie den QR-Code) und geben Sie den " +
    "Zugangscode ein, um den MOS Fragebogen auszufüllen. " +
    "Dieser Link kann nur einmal verwendet werden.";
  const instrLines = doc.splitTextToSize(instructions, pageWidth - margin * 2);
  doc.text(instrLines, margin, y);
  doc.setTextColor(0, 0, 0);
  y += instrLines.length * 5 + 6;

  // ── Download ─────────────────────────────────────────────────
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  const a = document.createElement("a");
  a.href = pdfUrl;
  a.download = `MOS-Link_${token}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
}
